export default __webpack_public_path__ + "static/media/redux.6f66dff1.jpg";